<template>
  <router-link
    v-if="pid"
    class="project-name-link"
    :to="{ path: '/project/detail', query: { id: String(pid) } }"
    :title="label"
    @click.native.stop
  >{{ label }}</router-link>
  <span v-else>{{ label }}</span>
</template>

<script>
export default {
  name: 'ProjectNameLink',
  props: {
    projectId: { type: [Number, String], default: null },
    name: { type: String, default: '' }
  },
  computed: {
    pid() {
      if (this.projectId == null || this.projectId === '') return null
      const n = Number(this.projectId)
      return Number.isNaN(n) ? null : n
    },
    label() {
      return this.name || '-'
    }
  }
}
</script>

<style scoped>
.project-name-link {
  color: #409eff;
  text-decoration: none;
}
.project-name-link:hover {
  text-decoration: underline;
}
</style>
